<template>
  <transition name="slide-fade">
    <v-container fluid>
      <v-layout wrap>
        <v-flex xs12 md12 sm12 lg9>
          <v-layout wrap>
            <v-flex xs12>
              <h3 class="text-center">{{ client.name }} - <small>{{ visit.date }}</small></h3>
              <p class="pull-right">
                <v-btn small icon :href="'/tiko_requests/' + visit.visitable_id" @click.stop.prevent="goTo('/tiko_requests/' + visit.visitable_id)" title="View TIKO Request" color="pink" v-if="visit.visitable_id" v-show="visit.visitable_type && visit.visitable_type.includes('Tiko')">
                  <v-icon>mdi-gender-female</v-icon>
                </v-btn>
                <v-btn small icon :href="'/service_requests/' + visit.service_request.id" @click.stop.prevent="goTo('/service_requests/' + visit.service_request.id)" title="View Request" color="primary" v-if="visit.service_request">
                  <v-icon>mdi-map-marker-plus-outline</v-icon>
                </v-btn>
                <v-btn color="primary" @click="goTo('/clients/' + client.id)" small>
                  <v-icon left>fa-arrow-left</v-icon>Back to Patient
                </v-btn>
                <invoices-button :href="'/clients/' + client.id + '/visits/' + visit.id + '/invoices'"></invoices-button>
                <v-btn small icon fab @click="viewCoupon = !viewCoupon" title="View discount coupon">
                  <v-icon>mdi-cash-minus</v-icon>
                </v-btn>
                <v-btn small fab icon @click="deleteVisit(visit)">
                  <v-icon color="red">{{ icons.delete }}</v-icon>
                </v-btn>
              </p>
            </v-flex>
            <v-flex xs12 sm4 md6 order-md1 class="pa-1" id="vitals">
              <v-card>
                <v-card-title class="pb-1 pt-1 primary">
                  Vitals
                  <v-spacer></v-spacer>
                  <v-btn v-if="!visit.vital" @click="addVital = !addVital" small>Add Vitals</v-btn>
                  <v-btn small color="orange" @click="editting = !editting" v-if="visit.vital">Edit Vitals</v-btn>
                </v-card-title>
                <v-card-text v-if="visit.vital" class="pt-0 pb-0">
                  <mk-details header="Weight">
                    <span v-html="vital.weight"></span> Kg
                  </mk-details>
                  <mk-details header="Height">
                    <span v-html="vital.height"></span> cm
                  </mk-details>
                  <mk-details header="B P">
                    <span v-html="vital.blood_pressure"></span>
                  </mk-details>
                  <mk-details header="Temperature ">
                    <span v-html="vital.temperature"></span>℃
                  </mk-details>
                  <mk-details header="Pulse">
                    <span v-html="vital.pulse"></span>
                  </mk-details>
                  <mk-details header="MUAC">
                    <span v-html="vital.mid_upper_arm_circumference"></span>
                  </mk-details>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm8 md6 order-md3 class="pa-1" id="history">
              <v-card>
                <v-card-title class="pb-1 pt-1 primary">
                  Significant Med History
                  <v-spacer></v-spacer>
                  <v-btn small text @click="addHistory = !addHistory">Add</v-btn>
                </v-card-title>
                <v-card-text class="pb-0 pt-0">
                  <histories-table :client="client" :histories="histories"></histories-table>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 order-md2 class="pa-1" id="presenting">
              <v-card>
                <v-card-title class="primary pt-1 pb-1">
                  Presenting Complaints
                  <v-spacer></v-spacer>
                  <v-btn small @click="addPresenting = !addPresenting">Add New</v-btn>
                </v-card-title>
                <v-card-text>
                  <presenting-complaints :client="client" :visit="visit" :complaints="visit.presenting_complaint"></presenting-complaints>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 order-md4 class="pa-1" id="impression">
              <v-card>
                <v-card-title class="primary pt-1 pb-1">
                  Impression
                  <v-spacer></v-spacer>
                  <v-btn small text @click="addImpression = !addImpression" v-if="!impression">Add</v-btn>
                  <v-btn small text @click="deleteImpression(impression)" v-if="impression" color="error">
                    <v-icon>{{ icons.delete }}</v-icon>
                  </v-btn>
                  <v-btn small text @click="editImpression = !editImpression" v-if="impression">Edit</v-btn>
                </v-card-title>
                <v-card-text>
                  <p v-if="impression" class="mb-0">{{ impression.comment }}</p>
                </v-card-text>
                <v-card-actions v-if="impression" class="pb-0 pt-0">
                  <v-spacer></v-spacer>
                  <span class="text-muted">By: {{ impression.user.name }}</span>
                </v-card-actions>
              </v-card>
            </v-flex>
            <v-flex xs12 sm9 md9 order-md5 class="pa-1" id="labtests">
              <v-card>
                <v-card-title class="primary pt-1 pb-1">
                  Laboratory Tests
                  <v-spacer></v-spacer>
                  <v-btn small class="secondary" @click.stop.prevent="goTo(visit.id + '/patient_tests/create')" :href="visit.id + '/patient_tests/create'">Add</v-btn>
                </v-card-title>
                <v-card-text>
                  <patient-tests-table :client="client" :visit="visit"></patient-tests-table>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm3 md3 order-md6 class="pa-1" id="more">
              <v-btn title="Diagnosis" small class="primary btn-block ma-1" :href="route('clients.visits.diagnoses.index', { client: client.id, visit: visit.id })" @click.stop.prevent="goTo(route('clients.visits.diagnoses.index', { client: client.id, visit: visit.id }))">
                Diagnosis
              </v-btn>
              <v-btn title="Treatment" small class="primary btn-block ma-1" @click.stop.prevent="goTo('/clients/' + client.id + '/visits/' + visit.id + '/treatments')" :href="'/clients/' + client.id + '/visits/' + visit.id + '/treatments'">
                Treatment
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 md3 sm12 lg3 class="visible-lg" style="position: fixed; right: 3px;">
          <v-card flat>
            <v-card-text>
              <p>On this Page</p>
              <ul class="list-unstyled">
                <li><a href="#vitals">Patient Vitals</a></li>
                <li><a href="#history">Medical History</a></li>
                <li><a href="#presenting">Presenting Complaints</a></li>
                <li><a href="#impression">Impressions</a></li>
                <li><a href="#labtests">Lab Test Request</a></li>
                <li>
                  <inertia-link title="Diagnosis" small :href="route('clients.visits.diagnoses.index', { client: client.id, visit: visit.id })">Diagnosis</inertia-link>
                </li>
                <li></li>
              </ul>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <modal-dialog :open="addVital" @close="addVital = false">
        <template slot="title">Add Vitals</template>
        <add-vitals :client="client" :visit="visit" @done="addVital = false"></add-vitals>
      </modal-dialog>
      <modal-dialog :open="editting" @close="editting = false">
        <template slot="title">Edit Vitals</template>
        <edit-vitals :client="client" :visit="visit" :vital="vital" @done="editting = false"></edit-vitals>
      </modal-dialog>
      <modal-dialog :open="addHistory" @close="addHistory = false">
        <template slot="title">Add Medical History</template>
        <create-history :client="client" @done="addHistory = false" @saved="addHistory = false"></create-history>
      </modal-dialog>
      <modal-dialog :open="addPresenting" @close="addPresenting = false">
        <template slot="title">Add Patient Complaint</template>
        <create-presenting :client="client" :visit="visit" @saved="addPresenting = false"></create-presenting>
      </modal-dialog>
      <modal-dialog :open="addImpression" @close="addImpression = false">
        <template slot="title">Add Impression</template>
        <add-impression-component :client="client" :visit="visit" @saved="addImpression = false"></add-impression-component>
      </modal-dialog>
      <modal-dialog :open="editImpression" @close="editImpression = false">
        <template slot="title">Edit Impression</template>
        <edit-impression-component :client="client" :visit="visit" :impression="impression" @saved="editImpression = false"></edit-impression-component>
      </modal-dialog>
      <mk-dialog v-model="viewCoupon">
        <template #title>Review coupons</template>
        <v-card>
          <v-card-title class="py-0">
            <v-spacer></v-spacer>
            <v-btn small title="Order a new coupon" @click="createCoupon" text outlined>Create new coupon</v-btn>
          </v-card-title>
          <v-card-text>
            <coupons-table :coupons="coupons"></coupons-table>
          </v-card-text>
        </v-card>
      </mk-dialog>
    </v-container>
  </transition>
</template>

<script>
  import Layout from '@/Layouts/MainLayout'
  const AddVitals = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "vitals" */ '@/Components/Vitals/create')
  const EditVitals = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "vitals" */ '@/Components/Vitals/edit')
  const CreateHistory = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "medical-histories" */ '@/Components/MedHistory/create')
  const HistoriesTable = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "medical-histories" */ '@/Components/MedHistory/index')
  const CreatePresenting = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "presenting" */ '@/Components/Presenting/create')
  const PresentingComplaints = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "presenting" */ '@/Components/Presenting/index')
  const AddImpressionComponent = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "impressions" */ '@/Components/Impressions/create')
  const EditImpressionComponent = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "impressions" */ '@/Components/Impressions/edit')
  const PatientTestsTable = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "client-tests" */ '@/Components/ClientTests/index')
  const CouponsTable = async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "coupons" */ '@/Components/Coupons/coupons')
  const MkDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/mk-dialog')
  const ModalDialog = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/dialog')
  const MkDetails = async () => await import(/* webpackMode: 'lazy' */ /* webpackChunkName: "main-components" */ '@/Components/components/details')

  export default {
    name: 'ViewVisit',
    metaInfo () {
      return {
        title: 'Patient\'s Visit - ' + this.client.name + ' - ' + this.visit.date,
        titleTemplate: '%s | ' + this.$title,
      }
    },
    components: {
      MkDialog,
      MkDetails,
      ModalDialog,
      AddVitals,
      EditVitals,
      CreateHistory,
      HistoriesTable,
      CreatePresenting,
      PresentingComplaints,
      AddImpressionComponent,
      EditImpressionComponent,
      PatientTestsTable,
      CouponsTable,
    },
    layout: Layout,
    props: [ 'client', 'visit', 'coupons'],
    data () {
      return {
        addHistory: false,
        addVital: false,
        editting: false,
        addPresenting:false,
        addImpression: false,
        editImpression: false,
        addTest: false,
        viewCoupon: false,
      }
    },
    methods: {
      deleteVisit (visit) {
        swal({
          title: visit.date,
          text: 'Are you sure to delete this visit and its data?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Delete',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.delete('/clients/' + this.client.id + '/visits/' + visit.id, {
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      },
      deleteImpression (impression) {
        swal({
          title: '',
          text: '',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Delete',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.delete('/clients/' +this.client.id + '/visits/' + this.visit.id + '/impressions/' + impression.id, {
            preserveScroll: true,
            onFinish: () => {
              swal.close()
            }
            })
        }.bind(this))
      },
      createCoupon () {
        swal({
          title: 'Create a discount coupon?',
          text: 'The percentage of discount and the time before it expires will be determined by the system settings managed by admins <br> If ' + this.client.name + ' has a user account, they will be notified of the new coupon, which is also accessible from the user\'s profile page. <br><b style="color: red; font-weight: 900;">Please note that coupons creation is not always immediate. Your request will join the queue and will be processed as soon as possible.</b>',
          // type: 'warning',
          showCancelButton: true,
          confirmButtonColor: 'red',
          confirmButtonText:'Ok',
          closeOnConfirm: false,
          showLoaderOnConfirm: true,
        },
        function () {
          this.$inertia.post('/coupons/review/' + this.visit.id, {}, {
            preserveScroll: true,
            preserveState: true,
            onFinish: () => {
              swal.close()
            }
          })
        }.bind(this))
      }
    },
    computed: {
      vital () {
        return this.visit.vital
      },
      histories () {
        return this.client.medical_histories
      },
      impression () {
        return this.visit.impression
      }
    },
  }
</script>

<style>
  /*  */
</style>
